import { render, staticRenderFns } from "./DevelopmentHistoryPage.vue?vue&type=template&id=f1261dc0&scoped=true"
import script from "./DevelopmentHistoryPage.vue?vue&type=script&lang=js"
export * from "./DevelopmentHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentHistoryPage.vue?vue&type=style&index=0&id=f1261dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1261dc0",
  null
  
)

export default component.exports